import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import Formsy from 'formsy-react';
import { FormsyText } from 'formsy-material-ui/lib';
import { cancellationReasonsEndpoint } from '../../../../settings/constants';
import globals from '../../../../globals/communityGlobals';
import TreatmentInstanceDialogHeader from './../TreatmentInstanceDialogHeader/TreatmentInstanceDialogHeader';
import ApiSelector from '../../../../containers/common/selectors/selectorContainer';
import { Treatment, TreatmentDefaultProps } from '../../../../propTypes/entities/treatment';
import treatmentInstancePropType from '../../../../propTypes/entities/treatmentInstance';
import { textFieldStyle, multiLineText } from '../../../../theme/AllocateBaseTheme';

const errorsLocale = globals.getArea('error');
const locale = globals.getArea('treatments');
const riskMaxLength = 500;
const styles = {
  submitButton: { display: 'flex', flexDirection: 'column' },
  backButton: { justifyContent: 'flex-start' },
  riskAssesment: { ...multiLineText.style, width: '100%' },
};
class TreatmentInstanceDialogCancellation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canSubmit: false,
    };
    this.errorMessages = {
      maxLength: errorsLocale.getMsg('validationMaxLength', [`${riskMaxLength}`]),
    };
    this.validations = { maxLength: riskMaxLength };
  }

  enableButton = () => {
    this.setState({
      canSubmit: true,
    });
  };

  disableButton = () => {
    this.setState({
      canSubmit: false,
    });
  };

  save = async model => {
    const { cancel, treatment, treatmentInstanceId, treatmentInstance, onClose, dateAt } = this.props;
    const { reasonId, riskAssesment } = model;

    try {
      await cancel(treatment.id, treatmentInstanceId, reasonId, riskAssesment, dateAt, treatmentInstance.timeSlots);
    } catch (error) {
      return;
    }

    onClose();
  };

  render() {
    const { onClose, onBack } = this.props;
    return (
      <Formsy.Form
        onValidSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
        onSubmit={this.save}
        style={styles.submitButton}
      >
        <TreatmentInstanceDialogHeader onClose={onClose}>
          {locale.getMsg('cancelTreatment')}
        </TreatmentInstanceDialogHeader>
        <div className="dialog-content">
          <div className="row">
            <ApiSelector
              name="reasonId"
              endpoint={cancellationReasonsEndpoint}
              reduxIdentifier="cancellationReasons"
              required
              className="select-field"
              floatingLabelText={`${locale.getMsg('cancellationReason')} *`}
              isFetchRequired
            />
          </div>
          <div className="row">
            <FormsyText
              name="riskAssesment"
              required
              multiLine
              fullWidth
              rows={4}
              rowsMax={12}
              validations={this.validations}
              validationErrors={this.errorMessages}
              className="formsytext-css"
              floatingLabelStyle={textFieldStyle.floatingLabelStyle}
              floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
              validationColor={textFieldStyle.validationColor}
              style={styles.riskAssesment}
              inputStyle={multiLineText.inputStyle}
              underlineStyle={multiLineText.underlineStyle}
              underlineFocusStyle={multiLineText.underlineFocusStyle}
              floatingLabelText={`${locale.getMsg('riskAssessment')} *`}
            />
          </div>
        </div>
        <div className="row" style={styles.backButton}>
          <FlatButton label={locale.getMsg('back')} onClick={onBack} />
          <FlatButton secondary type="submit" label={locale.getMsg('save')} disabled={!this.state.canSubmit} />
        </div>
      </Formsy.Form>
    );
  }
}

TreatmentInstanceDialogCancellation.defaultProps = {
  treatment: TreatmentDefaultProps,
  treatmentInstance: null,
};

TreatmentInstanceDialogCancellation.propTypes = {
  dateAt: PropTypes.string.isRequired,
  treatment: Treatment,
  treatmentInstance: treatmentInstancePropType,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default TreatmentInstanceDialogCancellation;
